module.exports = __webpack_public_path__ + "img/1首页产品图-汽车.b0feecb1.png";